import styled from 'styled-components';
import {Button, EMPHASIS} from '@forecast-it/design-system';

interface Props {
	selectedCount: number;
	onAssign: () => void;
	onClear: () => void;
	disabled?: boolean;
}

const Bar = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	border-radius: ${p => p.theme.ticketing.radius.m};
	border: 1px solid ${p => p.theme.ticketing.color.brand100};
	background: ${p => p.theme.ticketing.color.brand50};
	padding: 8px 16px;
	box-shadow: 0 1px 2px rgb(0 0 0 / 0.05);
`;

const CountLabel = styled.span`
	font: ${p => p.theme.ticketing.font.subheading2};
	color: ${p => p.theme.ticketing.color.dark700};
`;

export function BulkActionBar({selectedCount, onAssign, onClear, disabled}: Props) {
	return (
		<Bar>
			<CountLabel>{selectedCount} selected</CountLabel>
			<Button emphasis={EMPHASIS.HIGH} onPress={onAssign} disabled={disabled}>
				Assign selected
			</Button>
			<Button emphasis={EMPHASIS.MEDIUM} onPress={onClear}>
				Clear selection
			</Button>
		</Bar>
	);
}
